import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Channels } from "constant";
import Icon from "module-common/Icon";

export default class ChannelLimit extends Component {
  static propTypes = {
    channel: PropTypes.array,
    limit: PropTypes.number
  };
  static defaultProps = {
    limit: 0
  };

  render() {
    const { channel, limit } = this.props;
    let icon = [];

    channel.forEach(item => {
      let iconTemp;
      let ch;
      if (item.specificType === 1) {
        ch = this.getChannel("twitter");
      } else {
        ch = this.getChannel("facebook");
      }
      if (ch) iconTemp = ch.icon;
      icon.push({
        icon: iconTemp
      });
    });
    let logo;
    if (channel.length > 0) {
      logo = icon.map((row, index) => (
        <Wrapper key={"wrapper" + index}>
          <Icon name={row.icon} />
        </Wrapper>
      ));
    } else {
      logo = <Wrapper />;
    }
    return (
      <Wrapper>
        {logo}
        {limit === 0 ? "" : <Limit isMinus={limit < 0}>{limit}</Limit>}
      </Wrapper>
    );
  }

  getChannel = channel => {
    for (const ch of Channels) {
      if (ch.name === channel) {
        return ch;
      }
    }
  };
}
const Wrapper = styled.div`
  display: flex;
  flex-directon: row;
  align-items: center;
`;
const Limit = styled.div`
  font-size: 0.8rem;
  margin-left: 5px;
  color: ${props => (props.isMinus ? "red" : props.theme.uiText)};
`;



// WEBPACK FOOTER //
// ./src/module-schedule/ChannelLimit.js